import {cnCreateForm} from '../../FormModule';
import React, {useEffect} from 'react';
import {useFormContext} from 'react-hook-form';
import {IFormInput} from '../../initialValue';
import {IOption} from '../../../../../../../common-code/interfaces/option/IOption';
import {IOptionHiddenJson} from '../../../../../../../common-code/interfaces/option/IOptionHiddenJson';
import {
    FURNITURE_CELL_CORPUS, KIT_CODE_CHEAP,
    OPTION_TYPE_JSON
} from '../../../../../../../common-code/constants';
import {IKitFurniturePriceParam} from '../../../../../../../common-code/interfaces/catalog/IKitFurniturePriceParam';
import {Button} from '../../../../../components/Button';
import ModalKitFurnitureItem from './ModalKitFurnitureItem';
import Edit from '../../../../../components/icons/Edit';
import Trash from '../../../../../components/icons/Trash';
import {CommonHelper} from 'common-code';
import {KitchenService} from '../../../../../../3d/services/KitchenService/KitchenService';
import {TSizes} from '../../../../../../../common-code/types/geometry/TSizes';

export type TEditKitFurniture = {
    data: IKitFurniturePriceParam;
    parentSizes: TSizes;
    index?: number;
}

function KitFurniture({service} : {service: KitchenService}){
    const { setValue, getValues} = useFormContext<IFormInput>();
    const initData: IKitFurniturePriceParam[] = getValues("kitFurniture") ? (getValues("kitFurniture") as IOption).value : [];
    const [kitFurniture, setKitFurniture] = React.useState <IKitFurniturePriceParam[]>(initData);
    const [parentSizes] =  React.useState<TSizes>({
        width: (!isNaN(+getValues('depth')) ? +getValues('depth') : 0),
        height: (!isNaN(+getValues('height')) ? +getValues('height') : 0),
        length: (!isNaN(+getValues('defaultWidth')) ? +getValues('defaultWidth') : 0),
    });
    const optionKitFurniture: IOption = {
        id: "kitFurniture",
        type: OPTION_TYPE_JSON,
        title: "Фурнитура",
        sort: 0,
        value: kitFurniture,
    } as IOptionHiddenJson;

    useEffect(() => {
        setValue("kitFurniture", kitFurniture.length > 0 ? optionKitFurniture : null);
        // eslint-disable-next-line
    }, [optionKitFurniture]);
    const [editData, setEditData] = React.useState<TEditKitFurniture | undefined>(undefined);

    const saveEditData = (editData: TEditKitFurniture) => {
        if (editData.index && kitFurniture[editData.index]) {
            setKitFurniture(kitFurniture.map((item: IKitFurniturePriceParam, index: number) => {
                if (editData.index === index) {
                    return editData.data;
                } else {
                    return item;
                }
            }))
        } else {
            setKitFurniture([...kitFurniture, editData.data]);
        }
        setEditData(undefined);
    }
    const deleteKitFurniture = (deleteIndex: number) => {
        setKitFurniture(kitFurniture.filter((item: IKitFurniturePriceParam, index: number) => {
            return deleteIndex !== index;
        }));
    }
    const initialKitFurniture: IKitFurniturePriceParam = {
        cell: FURNITURE_CELL_CORPUS,
        functionalType: '',
        count: 1,
        kitCode: KIT_CODE_CHEAP,
    }

    return <>
        <h3 className={cnCreateForm('Header')}>Фурнитура комплектаций</h3>
        { kitFurniture.sort((a, b) =>
            CommonHelper.getKitCodeSort(a.kitCode) - CommonHelper.getKitCodeSort(b.kitCode)
        ).map((kitFurnitureItem: IKitFurniturePriceParam, index) =>
            <div key={index} className={cnCreateForm('KitFurniture')}>
                <div className={cnCreateForm("Children")}>
                    <span>Комплектация: <b>{CommonHelper.getKitCodeTitle(kitFurnitureItem.kitCode)}</b></span>
                    <span>Позиция: <b>{CommonHelper.getFurnitureCellTitle(kitFurnitureItem.cell)}</b></span>
                    <span>Тип 1С: <b>{kitFurnitureItem.functionalType}</b></span>
                    <span>Количество: <b>{kitFurnitureItem.count}</b></span>
                    <div className={cnCreateForm("Box-Btn")}>
                        <Edit handleToggleModal={() => {
                            setEditData({
                                data: kitFurnitureItem,
                                parentSizes: parentSizes,
                                index: index
                            });
                        }} />
                        <Trash handleDeleteValue={() => {
                            deleteKitFurniture(index)
                        }} />
                    </div>
                </div>
            </div>
        )}
        <div className={cnCreateForm('Container-Btn')}>
            <Button
                className={cnCreateForm('Button')}
                type={'button'}
                text={`Добавить фурнитуру`}
                leftIcon={ {path: 'plus2', width: 16, height: 16, marginRight: 8} }
                mods={{ mods: {bkg: 'white', color: 'lightGreen', border: 'lightGreen', fill: 'lightGreen'},
                    hover: {mods: {bkg: 'lightGreen', color: 'white', fill: 'white'}}}}
                callBack={() => {
                    setEditData({
                        data: initialKitFurniture,
                        parentSizes: parentSizes,
                    })
                }}
            />
        </div>
        {editData ? <ModalKitFurnitureItem showModal={!!editData}
                                           handleToggleModal={() => {setEditData(undefined)}}
                                           keyValue={'#addingKitFurnitureItem'}
                                           editData={editData}
                                           handleSubmit={saveEditData}
                                           service={service}
        /> : null}
    </>;
}

export default KitFurniture;